import React from 'react';


class Pizzahot extends React.Component{
    render(){
        return (
            <React.Fragment>
              <div className="Page">
                 <div className="OneApp">
                        <h5>PizzaHot</h5>
                        
                        <p align="center">
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/26EvtLvc7aw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen;" allowfullscreen></iframe>
                        </p>
                        
                        
                        
                        <p align="left">Página Web WordPress en servidor local para pizzería basada en pizza hat con plantilla personalizada.</p>
                        
                        <p align="left">Puedes ver el repositorio dando click <a href="https://github.com/BrandonGrimaldoM/PIZZAHOTWP" target="_blank" rel='noreferrer'>AQUI.</a></p>
                        
                        <div className="space"></div>
                        
                        
                 </div>
                 
                
             </div>
          
            </React.Fragment>
        ); 
    }
}

export default Pizzahot;